import React, { Component, useRef } from "react";
import { makeStyles, withStyles, useTheme, styled } from '@material-ui/core/styles';
import Save from '../../../../assets/img/svg/save.svg';
import Cancel from '../../../../assets/img/svg/cancel.svg';
import docIcon from '../../../../assets/img/svg/docIcon.svg';
import Delete from '../../../../assets/img/svg/delete.svg'
import { TextField, InputBase, InputAdornment, IconButton, Checkbox } from '@material-ui/core';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import { useNavigate } from "react-router-dom";
import Autocomplete from "react-autocomplete";
import $ from 'jquery';
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import styles from "../../../../assets/jss/customStyle";
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { getprojectpbddocinfo, addpbddocumentinfo, addpbddocinfo, downloadsinglepbddocs, deletemulitipbddocs, pbdlookupdescription } from "../../../../actions/PBDAction";
import del from "../../../../assets/img/svg/Del.svg"
import axios from "axios";
import API from "../../../../_helpers/endpointService";
import moment from "moment";
import { getSettingsFormat } from "../../../../actions/SettingsAction"
import { getlookupdocinfo } from "../../../../actions/MasterDataAction";

const BootstrapError = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 0,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #f44336',
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
    },
}))(InputBase);

const BootstrapInput = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 0,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #ced4da',
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
    },
}))(InputBase);


class AddPBD extends Component {
    constructor(props) {
        super(props);
        this.inputFile = React.createRef();
        this.state = {
            ProjectId: 0,
            Docs: [],
            isMobile: false,
            isError: false,
            cancel: false,
            delindex: 0,
            "DescriptionError": false,
            "DateError": false,
            addData: {
                "Id": 0,
                "ProjectId": 0,
                "Description": "",
                "Date": ""
            }
        }
    }

    AttachFiles = (e) => {
        this.inputFile.current.click();
    };

    setCheckbox = (str) => {
        this.state.Docs.map((i) => {
            if (str == i.fileName) {
                i.check = !i.check;
                this.setState({});
            }
        })
    };

    componentDidMount() {
        this.state.addData.ProjectId = parseInt(localStorage.getItem("DashId"));
        this.state.ProjectId = localStorage.getItem("DashId");
        this.state.UserRole = localStorage.getItem("UserRoles");
        this.setState({})
        this.props.dispatch(getlookupdocinfo("PreBeaching"))
        this.props.dispatch(getSettingsFormat(this.state.ProjectId))
        this.props.dispatch(pbdlookupdescription())
        this.interval = setInterval(() => {
            this.resize()
        }, 10);
    }
    componentWillUnmount() {
        clearInterval(this.interval);
        $("#Prebeaching1 .MuiListItemText-primary").removeClass("fw-bolder");
        $("#Prebeaching").addClass("d-none");
        $("#Prebeaching").removeClass("d-block");
        $("#PBDL").removeClass("active-color");
        $("#PBDT").removeClass("fw-bolder");
    };

    AddCancel1 = () => {
        if (this.state.cancel == true) {
            window.$("#cancelpopup").modal("show");
        }
        else {
            this.props.navigate(`/prebeachingdocuments`)
        }
    }

    AddCancel = () => {
        let data = {
            "Id": 0,
            "ProjectId": 0,
            "Description": "",

            "Date": ""
        }
        this.state.addData = data;
        this.state.Docs = [];
        this.setState({})
        this.props.navigate("/prebeachingdocuments")
    };

    AddSave = () => {
        if (this.state.addData.Description == "") {
            this.state.DescriptionError = true;
            this.setState({})
        }
        else {
            this.state.DescriptionError = false;
            this.setState({})
        }
        // if (this.state.others == true) {
        //     if (this.state.addData.Others == "") {
        //         this.state.OthersError = true;
        //         this.setState({})
        //     }
        //     else {
        //         this.state.OthersError = false;
        //         this.setState({})
        //     }
        // }
        if (this.state.addData.Date == "") {
            this.state.DateError = true;
            this.setState({})
        }
        else {
            this.state.DateError = false;
            this.setState({})
        }
        if (this.state.addData.Description !== '' && this.state.addData.Date !== '') {
            let formData = new FormData()
            Array.from(this.state.Docs).forEach(async (a) => {
                formData.append("attachments", a.fdata)
            })
            this.addpbddocinfo(this.state.addData, formData, this.state.ProjectId)

        }
    }
    addpbddocinfo = (data, formData) => {
        let apiUrl = API.PBD_LISTVIEW;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "POST",
            url: apiUrl,
            data: data,

        })
            .then((response) => {
                if (response?.status === 200) {
                    this.adduploadpbddocinfo(formData, response.data)
                } else {
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                }
            });
    };
    adduploadpbddocinfo = (data, id) => {
        let apiUrl = API.PBD_LISTVIEW + '/' + id;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "POST",
            url: apiUrl,
            data: data,

        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.props.navigate("/prebeachingdocuments")

                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })

                if (error?.response?.status === 401) {

                }
            });
    };

    renderProjectNames = (state, val) => {
        return state?.Name?.toLowerCase().indexOf(val?.toLowerCase()) !== -1;
    };

    handleProjectNameSearchChange = (e) => {
        this.state.addData.Description = e.target.value;
        this.setState({});
        // if (this.state.addData.Description == 'others') {
        //     this.state.others = true;
        //     this.setState({});
        // }
        // else {
        //     this.state.others = false;
        //     this.setState({});
        // }
    };

    handleProjectNameSelectChange = (e) => {
        this.state.addData.Description = e;
        this.setState({});
        // if (this.state.addData.Description == 'others') {
        //     this.state.others = true;
        //     this.setState({});
        // }
        // else {
        //     this.state.others = false;
        //     this.setState({});
        // }
    };

    sidebar = () => {
        this.props.navigate("/sidebar");
    };

    OpenPopup = (i) => {
        this.state.delindex = i;
        this.setState({})
        window.$("#deletepopup").modal("show");
    }

    DeleteItem = () => {
        let tempData = [];
        this.state.Docs.map((i, a) => {
            if (a != this.state.delindex) {
                tempData.push(i)
            }
        })
        this.state.Docs = tempData;
        this.setState({})
        window.$("#deletepopup").modal("hide");
    }

    UploadFile = (e) => {
        Array.from(e.target.files).forEach(async (a) => {
            let upload = {
                fileName: a.name,
                size: a.size,
                check: false,
                fdata: a,
            }
            this.state.Docs.push(upload)
            this.setState({})
        })
    };

    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
        $("#Prebeaching1 .MuiListItemText-primary").addClass("fw-bolder");
        $("#Prebeaching").removeClass("d-none");
        $("#Prebeaching").addClass("d-block");
        $("#PBDL").addClass("active-color");
        $("#PBDT").addClass("fw-bolder");
    };

    handleInputChange = (e, str) => {
        this.state.addData[str] = e.target.value;
        this.setState({})
    };

    render() {
        let { classes, menuToggle } = this.props;
        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row w-100 mt-4">
                                <div className="col-6 mt-auto">
                                    <List className="pt-3 mt-4 pl-3" style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={this.sidebar} >
                                            <ListItemText id={"Prebeaching" + "1"} className='  textNaviIcon' primary="Daily Tasks" />
                                            <NavigateNextIcon id="Prebeaching" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider className='border-bottom' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-6 pt-2 mt-5 ">
                                    <h4>Pre-Beaching / Landing Documents</h4>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }
                <div className={`${this.state.isMobile ? "ml-auto scroll-hide" : "ml-auto"}`} style={{ backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -95 }}>
                    {this.state.isMobile ?
                        <table className="dataTable border-top" width="100%">
                            <tbody>
                                <tr>
                                    <td className="border-right text-center"><i class="fa fa-arrow-left cursorPointer" onClick={this.AddCancel1}></i></td>
                                <td className="border-right text-center">
                                    <button className={classes.button} onClick={this.AddSave}><img src={Save} style={{ marginTop: '-4px' }}></img>&nbsp;Save</button>
                                </td>
                                <td className="text-center">
                                    <button className={classes.button} onClick={this.AddCancel1}><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</button>
                                </td>
                                    {/* <td className="border-right text-center">
                                        <button className={`${classes.button} pl-3`} data-target="#deletepopup" data-toggle="modal" ><img src={Delete} style={{ marginTop: '-4px' }}></img>&nbsp;Delete</button>
                                    </td> */}
                                </tr>
                            </tbody>
                        </table>
                        :
                        <table className="dataTable" width="100%">
                            <tbody>
                                <tr>
                                <td width="5%" className="border-right text-center">
                                                <i class="fa fa-arrow-left cursorPointer" onClick={this.AddCancel1}></i></td>
                                    <td width="95%">
                                        <button className={classes.button} onClick={this.AddSave} style={{ minWidth: '70px' }}><img src={Save} style={{ marginTop: '-4px' }}></img>&nbsp;Save</button>
                                        <button className={`${classes.button} `}style={{ minWidth: '70px' }}  onClick={this.AddCancel1} ><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>}
                    <div style={{ margin: this.state.isMobile ? "auto" : "15px 45px" }}>
                        {this.state.isMobile ? "" : <h6 className="col-12 ml-2">Pre-Beaching / Landing Documents</h6>}
                        <div className="row px-4">
                            <div className="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 mt-2">
                                <label>Description :</label>
                            </div>
                            <div className="col-12 col-sm-12 pb-4 col-md-12 col-lg-4 col-xl-4 mt-2">
                                <div className="autocomplete-wrappers">
                                    {this.state.DescriptionError ? <>
                                        <Autocomplete
                                            contentEditable={true}
                                            value={this.state.addData.Description}
                                            inputProps={{
                                                placeholder: "Description",
                                            }}
                                            items={this.props.PBDDESC_LOOKUP ?? []}
                                            getItemValue={(item) => item.Name}
                                            shouldItemRender={this.renderProjectNames.bind(this)}
                                            renderMenu={(item) => (
                                                <div className="dropdowns d-block" >{item}</div>
                                            )}
                                            renderInput={(props) => {
                                                return (
                                                    <input
                                                        className="form-control border-radius"
                                                        id="exampleFormControlInput1"
                                                        {...props}
                                                        fullWidth
                                                        style={{ width: '100%', height: 35, fontSize: 12, color: "#000000", borderColor: 'red' }}
                                                    />
                                                );
                                            }}
                                            renderItem={(item, isHighlighted) => (
                                                <div
                                                    className={`items 
                                          ${isHighlighted ? "selected-items" : ""
                                                        }`}
                                                >
                                                    {item.Name}
                                                </div>
                                            )}
                                            onChange={(e) => this.handleProjectNameSearchChange(e)}
                                            onSelect={(e) => this.handleProjectNameSelectChange(e)}
                                        />
                                        <div className="helperText pt-1">
                                            <p style={{ color: 'red' }}> Required field must be filled in</p>
                                        </div></>
                                        :
                                        <Autocomplete
                                            contentEditable={true}
                                            value={this.state.addData.Description}
                                            inputProps={{
                                                placeholder: "Description",
                                            }}
                                            items={this.props.PBDDESC_LOOKUP ?? []}
                                            getItemValue={(item) => item.Name}
                                            shouldItemRender={this.renderProjectNames.bind(this)}
                                            renderMenu={(item) => (
                                                <div className="dropdowns d-block" >{item}</div>
                                            )}
                                            renderInput={(props) => {
                                                return (
                                                    <input
                                                        className="form-control border-radius"
                                                        id="exampleFormControlInput1"
                                                        {...props}
                                                        // fullWidth
                                                        style={{ width: '100%', height: 35, fontSize: 12, color: "#000000" }}
                                                    // style={{ width: this.state.isMobile ? 100 : 223, height: 32, fontSize: 12, color: "#000000" }}
                                                    />
                                                );
                                            }}
                                            renderItem={(item, isHighlighted) => (
                                                <div
                                                    className={`items 
                                          ${isHighlighted ? "selected-items" : ""
                                                        }`}
                                                >
                                                    {item.Name}
                                                </div>
                                            )}
                                            onChange={(e) => this.handleProjectNameSearchChange(e)}
                                            onSelect={(e) => this.handleProjectNameSelectChange(e)}
                                        />}
                                </div>
                            </div>
                            {/* {this.state.others == true ? <>
                                <div className="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 mt-2">
                                    <label>others :</label>
                                </div>
                                <div className="col-12 col-sm-12 pb-4 col-md-12 col-lg-4 col-xl-4 mt-2">
                                    {this.state.OthersError ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            value={this.state.addData.Others}
                                            onChange={(e) => this.handleInputChange(e, "Others")}
                                            helperText="Required field must be filled in"
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                            classes={{ root: classes.helperText }}
                                        />
                                        :
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            value={this.state.addData.Others}
                                            onChange={(e) => this.handleInputChange(e, "Others")}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />
                                    }
                                </div></> : <></>} */}
                            <div className="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 mt-2">
                                <label>Date :</label>
                            </div>
                            <div className="col-12 col-sm-12 pb-4 col-md-12 col-lg-4 col-xl-4 mt-2">
                                {this.state.DateError ?
                                    <TextField
                                        type="date"
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        error
                                        value={this.state.addData.Date}
                                        onChange={(e) => { this.handleInputChange(e, "Date") }}
                                        format={'DD/MM/YYYY'}
                                        helperText="Required field must be filled in"
                                        InputProps={{
                                            className: `border-radius ${classes.inputfieldAlign}`
                                        }}
                                        classes={{ root: classes.helperText }}
                                    />
                                    :
                                    <TextField
                                        type="date"
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        placeholder="dd/mm/yyyy"
                                        value={this.state.addData.Date}
                                        onChange={(e) => { this.handleInputChange(e, "Date") }}
                                        InputProps={{
                                            className: `border-radius ${classes.inputfieldAlign}`
                                        }}
                                    />
                                }
                            </div>
                            <div className="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 mt-2">
                                <label>Attachments <label style={{ whiteSpace: 'nowrap' }}>:</label></label>
                            </div>
                            <div className="col-12 col-sm-12 pb-4 col-md-12 col-lg-4 col-xl-4 mt-2">
                                <TextField
                                    disabled
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    accept=".pdf"
                                    placeholder="Browse File"
                                    onChange={(e) => this.UploadFile(e)}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment className="mr-0">
                                                <IconButton className="rotate p-0" onClick={this.AttachFiles}>
                                                    <AttachFileIcon />
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                        className: `border-radius ${classes.inputfieldAlign}`
                                    }}
                                />
                                <input
                                    hidden
                                    onChange={(e) => this.UploadFile(e)}
                                    accept=".pdf"
                                    type="file"
                                    ref={this.inputFile}
                                />
                                {this.state.Docs.map((m, i) => (
                                    <div className="row pt-3">
                                        <div className="col-1 col-sm-1 col-lg-1 col-xl-1 col-md-1 pt-1">
                                            <label class="contCheck">
                                                <input type="checkbox" checked={m.check} onChange={() => this.setCheckbox(m.fileName)} ></input>
                                                <span class="checkmark"></span>
                                            </label>
                                        </div>
                                        <div className="col-1 col-sm-1 col-lg-1 col-xl-1 col-md-1">
                                            <img src={docIcon} />
                                        </div>
                                        <div className="col-9 col-sm-9 col-lg-9 col-xl-9 col-md-9 pl-4" >
                                            <label className="fw-700">{m.fileName}<br></br><label style={{ color: "#B0AAAA" }}>{(m.size / 1048576).toFixed(2)}&nbsp;MB</label></label>
                                        </div>
                                        {m.check == true ?
                                            <div className="col-1 col-sm-1 col-lg-1 col-xl-1 col-md-1 pt-1 pt-2 pl-0 pr-0 mr-0 space">
                                                <img src={Delete} className="cursorPointer" onClick={() => { this.OpenPopup(i) }} />
                                            </div> : <></>}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal fade p-5 mt-5" id="deletepopup" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                    <div class="modal-dialog" role="document">
                        <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                            <div class="modal-body pb-0">
                                <h1 className="text-center">
                                    <img src={del}></img>
                                </h1>
                                <div className="text-center">
                                    <h5 class="fw-bold">Are you sure you want to delete?</h5> </div>
                            </div>
                            <div class="modal-footer border-top-0 m-auto">
                                <button type="button" data-dismiss="modal" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} style={{ backgroundColor: "#00838F", border: "none" }} onClick={() => this.DeleteItem()}><span className="" >Delete</span></button>
                                <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => { window.$("#deletepopup").modal("hide") }} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        PBDDESC_LOOKUP: state.MasterDataReducer.Lookup_data || [],
        settings: state.commonReducer.settings || [],
    };
}

AddPBD.propTypes = {
    classes: PropTypes.object.isRequired,
}
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AddPBD))
);
